import httpClient from './httpClient';

const API_BASE = '/api/contracts';

export const contractService = {
  async extractContract(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await httpClient.post(`${API_BASE}/extract`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async previewContracts(contracts) {
    const response = await httpClient.post(`${API_BASE}/preview`, {
      contracts,
    });
    return response.data;
  },

  async createDraftPOs(contracts) {
    const response = await httpClient.post(`${API_BASE}/create`, {
      contracts,
    });
    return response.data;
  },

  async confirmPOs(poIds) {
    const response = await httpClient.post(`${API_BASE}/confirm`, {
      po_ids: poIds,
    });
    return response.data;
  },

  async importContracts(contracts) {
    const response = await httpClient.post(`${API_BASE}/import`, {
      contracts,
    });
    return response.data;
  },

  async getImportHistory(page = 1, limit = 20) {
    const response = await httpClient.get(`${API_BASE}/import-history`, {
      params: { page, limit },
    });
    return response.data;
  },

  async deleteImportHistory(historyId) {
    const response = await httpClient.delete(`${API_BASE}/import-history/${historyId}`);
    return response.data;
  },
};

export default contractService;
